import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-charge-form',
    templateUrl: './charge-form.component.html',
    styleUrls: ['./charge-form.component.less'],
    standalone: false
})
export class ChargeFormComponent implements OnInit {

  constructor(private logger:NGXLogger,private formBuilder:FormBuilder,private dailog:MatDialog,
              private router:Router,private service:DataService,private utilityService:UtilityService,
              private activatedRoute:ActivatedRoute,private permissionService:PermissionService) { }

  showStatus:string;
  showDeactivateToggle=false;
  showReactivateToggle=false;
  checked:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  editPermission:boolean=false;
  addPermission:boolean=false;
  isEditedData:boolean=false;
  disableSubmit:boolean=false;
  chargeForm:FormGroup;
  chargeTypes:any;
  unitTypes: any;
  chargeCategories: any;
  viewLog = this.formBuilder.control(false);

  ngOnInit(): void {
    this.getAllPermissions();
    this.initializeForm();
    this.getChargeTypes();
    this.getUnitType();
    this.getChargeCategory();
    this.getParamId();
    this.viewLog.setValue(false);
    this.type.valueChanges.subscribe((value: string) => {
      if (value === 'INDIRECT') {
        this.unitType.setValue('OTHERS');
        this.unitType.disable();
      }
      else {
        this.unitType.reset();
        this.unitType.enable();
      }
    });
  }

  private getParamId() {
    this.activatedRoute.params.subscribe(
      (param: Params) => {
        if (+param['id']) {
          this.id.setValue(+param['id']);
          this.getChargeById();
        }
    });
  }

  private initializeForm() {
    this.chargeForm=this.formBuilder.group({
        id:[],
        parentId:[],
        name:[null,[Validators.required]],
        code:[null,[Validators.required,Validators.maxLength(6)]],
        type:[null,[Validators.required]],
        unitType:[null,[Validators.required]],
        chargeCategory:[null,[Validators.required]],
        status:[],
        active:[],
        deactivate:[],
        reactivate:[],
    });
  }

  private openDailog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });
  
    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.CHARGE_LIST]);
            // this.dailogRef.close();
          }
          else{
            this.saveCharge();
          }
        }
    })
  }
  
  public cancel() {
    if(this.chargeForm.dirty){
      this.isEditedData=false;
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
    }
    else{
      this.router.navigate([APP_ROUTES.CHARGE_LIST]);
    }
  }
  
  public save() {  
    this.chargeForm.markAllAsTouched();
    if(this.chargeForm.valid){
      this.isEditedData=true;
      if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
      }
      else {
        this.openDailog(Message.SAVE_OPEN_DAILOG);
      }  
    }
  }
  
  saveCharge(){
    this.chargeForm.markAllAsTouched();
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.chargeForm.valid){
      this.logger.info('Charge Form Value',this.chargeForm.getRawValue());
      this.service[method](Api.CHARGE, this.chargeForm.getRawValue()).subscribe(res => {
        this.utilityService.notifier(`Charge ${message} successfully`, 'success');
        this.router.navigate([APP_ROUTES.CHARGE_LIST]);
      });
    }
  }
  
  openDeactivateForm(e:MatSlideToggleChange){
      let data={id:this.id.value,message:'Charge Details',api:Api.DEACTIVATE_CHARGE,route:APP_ROUTES.CHARGE_LIST}
      const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(value => {
        this.checked = !this.checked;
    })
  }
  
  openReactivateForm(e:MatSlideToggleChange){
    let data={id:this.id.value,message:'Charge Details',api:Api.REACTIVATE_CHARGE,route:APP_ROUTES.CHARGE_LIST}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })
  }

  private getChargeById(){
    if(this.id.value){
      this.service.get(Api.CHARGE+'/'+this.id.value).subscribe(res => {
        if(res){
          this.logger.info('Charge By Id Res',res);
          this.showStatus=this.getStatus(res);
          this.chargeForm.patchValue(res);
          if(res.submittedForApproval || res.status==='DEACTIVATED'){
            this.chargeForm.disable();
            this.disableSubmit=true;
          }
        }
      });
    }
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivate?.deactivationWefDate,
        reactivationWefDate: data.reactivate?.reactivationWefDate});
    }
  }

  private getChargeTypes(){
    this.service.get(Api.CHARGE_TYPES).subscribe(res => {
      this.logger.info("Charge Types",res);
       this.chargeTypes=res;
    });
  }

  private getUnitType() {
    this.service.get(Api.UNIT_TYPE).subscribe(res => {
      this.logger.info("Unit Types",res);
      this.unitTypes = res;
    });
  }

  private getChargeCategory() {
    this.service.get(Api.CHARGE_CATEGORY).subscribe(res => {
      this.logger.info("CHARGE_CATEGORY",res);
      this.chargeCategories = res;
      this.logger.info("CHARGE_CATEGORY",this.chargeCategories);
    });
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.CHARGE_REACTIVATE_PERMISSION,PermissionKey.CHARGE_DEACTIVATE_PERMISSION,PermissionKey.CHARGE_EDIT_PERMISSION,
                        PermissionKey.CHARGE_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.CHARGE);
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_DEACTIVATE_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_ADD_PERMISSION})?.show?true:false;
  }

  get id() { return this.chargeForm.get('id'); }
  get name() { return this.chargeForm.get('name'); }
  get code() { return this.chargeForm.get('code'); }
  get type() { return this.chargeForm.get('type'); }
  get unitType() { return this.chargeForm.get('unitType'); }
  get chargeCategory() { return this.chargeForm.get('chargeCategory'); }

}
